import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/dictionariesType",
    name: "dictionariesType",
    component: dashboard,
    redirect: {
      name: "mediaTypeIndex"
    },
    children: [
      {
        path: "mediaTypeIndex",
        name: "mediaTypeIndex",
        meta: { title: "媒体分类" },
        component: () => import("@/views/mediaType/index.vue"),
        children: []
      }
    ]
  }
];
